export default __webpack_public_path__ + "static/media/mag2.2d9a933a.png";